import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services/authentication.service';
import { StatusCode } from '../_enums/Common';
import { IdServer } from '../_enums/idServer';
import { CommonService } from '../_services/app.common.service';



@Injectable()
export class TokenResolver implements Resolve<any> {
  constructor(public authService: AuthenticationService, private router: Router, private common: CommonService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    const tokenType = route.data.tokenType;
    return this.authService.GetTokenByType(tokenType).map(response => {
      
      if (response) {
        if (IdServer.TokenType.Sso == tokenType) {
          this.common.SetAccessToken(response.resultData);
          //let url = this.authService.getRedirectUrl();
          //this.router.navigateByUrl(url);
          
          this.authService.GetOwnSecurityRole();
        }
        if (IdServer.TokenType.SSOLogin == tokenType) {
          location.href = response.resultData;
        }
        return response;
      } else {
        //this.router.navigate(['404']);
        return null;
      }
    }, (error: any) => {
      console.log(error);
    });


  }
} 
